import { DataFieldRuleValidator } from "./types";

export const dataFieldRegex: DataFieldRuleValidator = {
	validate({ isImplicitlyRequired }, _, dataFieldValue, ruleValue): boolean {
		if (dataFieldValue === null || dataFieldValue === undefined) {
			return !isImplicitlyRequired;
		}
		return new RegExp(ruleValue as string).test(dataFieldValue as any);
	},
	getErrorMessage({ t }): string {
		return t("The value entered does not match the expected format.");
	},
};
